import { sortBy } from 'lodash'
const defaultName = 'default'
export const remove = (arr = [], name = defaultName) => {
  if (name.indexOf('#') > -1) {
    const [id, index = null] = name.split('#')
    return arr.filter(item => item.id !== id && item.order !== index)
  } else {
    return arr.filter(item => item.id !== name)
  }
}
export const convert = (name = defaultName) => {
  const [id, index] = name.split('#')
  return {
    id: id || defaultName,
    index: parseInt(index, 10) || 1000
  }
}
export const sort = (arr = []) => {
  return sortBy(arr, ['index'])
}

export const toType = obj => {
  return Object.prototype.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase()
}
